var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-snackbar',{ref:"snackbar",attrs:{"md-position":"bottom center","md-duration":_vm.duration}},[_c('pre',[_vm._v(_vm._s(_vm.text))]),_c('md-button',{staticClass:"md-accent",on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v(_vm._s(_vm.buttonText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }